import React, { useRef, useState, useMemo, useEffect } from 'react';
import { useAuth } from '../../hooks/AuthProvider';
import JoditEditor from 'jodit-react';
import axios from 'axios';
import { Box } from 'reflexbox';
import DOMPurify from 'dompurify';

export const Admin = ({ placeholder }) => {
    const [article, setArticle] = useState([]);
    
    useEffect(() => {
        // axios.get(`http://127.0.0.1:8000/`)
        //     .then(res => {
        //         setArticle(res.data);
        //     })
        //     .catch(error => {
        //         console.error('Error fetching articles:', error);
        //     });
    }, []);

    const editor = useRef(null);
    const config = useMemo(() => ({
        readonly: false, // all options from https://xdsoft.net/jodit/docs/,
        placeholder: placeholder || 'Start typings...'
        }),
        [placeholder]
    );
    
    const auth = useAuth();

    return (
        <Box padding="20px">
            <h1>Admin Dashboard</h1>
            <button 
                type="submit" 
                className="w-60 
                    text-white 
                    bg-primary-600 
                    hover:bg-primary-700 
                    focus:ring-4 
                    focus:outline-none 
                    focus:ring-primary-300 
                    font-medium 
                    rounded-lg 
                    text-sm 
                    px-5 
                    py-2.5 
                    text-center 
                    dark:bg-primary-600 
                    dark:hover:bg-primary-700 
                    dark:focus:ring-primary-800"
                    onClick={() => {
                        window.location.href = "/create-article";
                    }}
            >
                Create Article
            </button>
            <div>
                {article.length !== 0 && article.items.map((data, index) => (
                    <Box 
                        key={index} 
                        padding="20px" 
                        margin="20px" 
                        sx={{ border: '1px solid #000' }}
                        borderRadius="4px"
                    >
                        <div className="text-black text-2xl font-bold">
                            {data.title}
                        </div>
                        <div className="text-black" dangerouslySetInnerHTML={{ 
                            __html: DOMPurify.sanitize(data.description) 
                        }} />
                        <Box marginTop="20px">
                            <button 
                                type="submit" 
                                className="w-60 
                                    text-white 
                                    bg-blue-600 
                                    hover:bg-blue-700 
                                    focus:ring-4 
                                    focus:outline-none 
                                    focus:ring-blue-300 
                                    font-medium 
                                    rounded-lg 
                                    text-sm 
                                    px-5 
                                    py-2.5 
                                    text-center 
                                    dark:bg-blue-600 
                                    dark:hover:bg-blue-700 
                                    dark:focus:ring-blue-800"
                                onClick={() => {
                                    window.location.href = `/edit-article/${data.id}`;
                                }}
                            >
                                Edit
                            </button>
                            <Box marginLeft="20px" display="inline-block">
                                <button 
                                    type="submit" 
                                    className="w-60 
                                        text-white 
                                        bg-red-600 
                                        hover:bg-red-700 
                                        font-medium 
                                        rounded-lg 
                                        text-sm 
                                        px-5 
                                        py-2.5 
                                        text-center 
                                        dark:bg-red-600 
                                        dark:hover:bg-red-700"
                                    onClick={() => {
                                        // axios.delete(`http://127.0.0.1:8000/article/${data.id}`)
                                        //     .then(res => {
                                        //         console.log(res);
                                        //         window.location.reload();
                                        //     })
                                        //     .catch(error => {
                                        //         console.error('Error deleting article:', error);
                                        //     });
                                    }}
                                >
                                    Delete
                                </button>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </div>

            <Box marginTop="20px">
                <button 
                    type="submit" 
                    className="w-60 
                        text-white 
                        bg-primary-600 
                        hover:bg-primary-700 
                        focus:ring-4 
                        focus:outline-none 
                        focus:ring-primary-300 
                        font-medium 
                        rounded-lg 
                        text-sm 
                        px-5 
                        py-2.5 
                        text-center 
                        dark:bg-primary-600 
                        dark:hover:bg-primary-700 
                        dark:focus:ring-primary-800"
                        onClick={() => auth.logOut()}
                >
                    Logout
                </button>
            </Box>
        </Box>
    )
}